import { useState } from "react";

import NafutelTableComponent from "src/components/nafutel-table";
import { useTranslation } from "react-i18next";
import {
  IColumn,
  PATH_URL,
  IResaleReservation,
  EReservationType,
  IStatusCode,
  INafutelPagination,
} from "src/interfaces";
import { AuthedServices } from "src/services";
import { useNavigate } from "react-router-dom";
import { get, chunk } from "lodash";
import { Tooltip } from "antd";
import NafutelRootLoadingComponent from "src/components/nafutel-loading";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { buyOptions } from "src/pages/reservation-list/components/search/types";
import { convertUtcToJapanDate } from "src/utils/datetime";
import NafutelPaginationComponent from "src/components/nafutel-pagination";
import ReservationSearchComponent from "src/pages/reservation-list/components/search";

interface IProps {
  isResale?: boolean;
}

function ReservationListTab1Component(props: IProps) {
  const { t } = useTranslation();

  const [list, setList] = useState<IResaleReservation[]>([]);
  const [initList, setInitList] = useState<IResaleReservation[][]>([]);

  const [loading, setLoading] = useState(false);
  const navigrate = useNavigate();
  const [pagination, setPagination] = useState<INafutelPagination>({
    total: 0,
    size: 10,
    page: 1,
  });
  const EReservationTypeText = {
    reserve: t("reservation_list.resale.reserve"),
    resale: t("reservation_list.resale.resale"),
  };

  const columns: IColumn[] | any[] = [
    {
      title: t("reservation_list.table_id"),
      dataIndex: "",
      alignCenter: true,
      style: { backgroundColor: "#182D4A", color: "#ffffff", width: "48px" },
      tdCss: {
        backgroundColor: "#182D4A",
        color: "#ffffff",
        width: "48px",
        fontSize: 14,
      },
      render: (row) => {
        return (
          <Tooltip
            title={() => {
              return <div>{row?.sort}</div>;
            }}
          >
            <span>{row?.sort.substring(row?.sort.length - 5)}</span>
          </Tooltip>
        );
      },
    },
    {
      title: t("reservation_list.table_type"),
      dataIndex: "",
      alignCenter: true,
      style: { backgroundColor: "#9C8B58", color: "#ffffff", width: "80px" },
      tdCss: (row: any) => {
        return {
          backgroundColor:
            get(row, "reservation_type") === EReservationType.RESERVE
              ? "#9C8B58"
              : "#3F9BC0",
          color: "#ffffff",
          minWidth: "80px",
          fontSize: 14,
        };
      },
      render: (row) => {
        return `${get(EReservationTypeText, get(row, "reservation_type"))}`;
      },
    },
    {
      title: t("reservation_list.table_name_hotel"),
      dataIndex: "hotel_name",
      alignCenter: true,
      tdCss: {
        minWidth: isMobile ? "272px" : "200px",
        fontSize: 14,
        color: "#000000",
        whiteSpace: "nowrap",
      },
    },
    {
      title: t("reservation_list.table_staying_plan"),
      dataIndex: "plan.name",
      tdCss: {
        width: isMobile ? "272px" : "",
        fontSize: 14,
        color: " #000000",
        whiteSpace: isMobile ? "nowrap" : "normal",
        padding: 13,
      },
      alignCenter: true,
    },
    {
      title: t("reservation_list.table_date"),
      tdCss: {
        width: "154px",
        fontSize: 14,
        color: " #000000",
        whiteSpace: "nowrap",
        padding: 13,
      },
      alignCenter: true,
      render: (row) => {
        return `${convertUtcToJapanDate(
          get(row, "start_date")
        )}~${convertUtcToJapanDate(get(row, "end_date"))}`;
      },
    },
    {
      title: t("reservation_list.table_number_guest"),
      tdCss: {
        width: "92px",
        fontSize: 14,
        color: " #000000",
        whiteSpace: "nowrap",
      },
      alignCenter: true,
      render: (row) => {
        return get(row, "rooms", []).reduce(
          (partialSum: number, a: any) =>
            partialSum + get(a, "adult") + get(a, "childrens"),
          0
        );
      },
    },
  ];

  const handleApi = (condition: any) => {
    setLoading(true);
    setPagination({
      total: 0,
      size: 10,
      page: 1,
    });
    AuthedServices.getListReservationByUserLogged(condition)
      .then((response: any) => {
        if (
          response &&
          response.data &&
          response.data.reservations &&
          response.status_code === IStatusCode.OK
        ) {
          const data = response.data?.reservations || [];
          if (data.length > 0) {
            const list_chunk: any[] = chunk(data, pagination.size);
            setList(list_chunk[0] || []);
            setInitList(list_chunk);
            setPagination((pre) => {
              return {
                ...pre,
                total: data.length || 0,
              };
            });
          } else {
            setList([]);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangePagination = (page: any) => {
    setPagination((pre: any) => {
      return {
        ...pre,
        page,
      };
    });
    const index = page - 1;
    if (initList[index]) {
      setList(initList[index]);
    }
  };

  return (
    <div>
      {loading && <NafutelRootLoadingComponent />}
      <div style={{ marginTop: isMobile ? 30 : 20 }}>
        <ReservationSearchComponent
          parentCss={{
            position: "relative",
            gridTemplateColumns: !isMobile ? "auto 160px" : "",
            backgroundColor: isMobile ? "transparent" : "#24305A",
          }}
          styleLeftBg={{
            backgroundColor: "#ffffff",
            border: "none",
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.16)",
            padding: 15,
          }}
          styleRightBg={{
            backgroundColor: "#24305A",
            color: "#ffffff",
          }}
          styleTextCheckbox={{ color: "#000000" }}
          listCheckbox={buyOptions()}
          callback={handleApi}
        />
      </div>

      <div
        style={{
          width: isMobileOnly
            ? window.screen.width - 16
            : isTablet
            ? window.screen.width - 100
            : undefined,
          overflow: isMobile ? "scroll" : "auto",
        }}
      >
        <NafutelTableComponent
          columns={columns}
          dataSource={list}
          styleHeader={{
            fontSize: 14,
          }}
          styleTable={{ marginTop: 32 }}
          rowStyle={{ textAlign: "center", fontSize: 14 }}
          rowClick={(row) => {
            const url =
              PATH_URL.RESERVATION_DETAIL +
              "/" +
              get(row, "sort") +
              "?menu=2&reservation_list_tab_active=0";
            return navigrate(url);
          }}
        />
      </div>

      <NafutelPaginationComponent
        pagination={pagination}
        onChange={onChangePagination}
        style={{ marginTop: 20, display: "flex", justifyContent: "center" }}
      />
    </div>
  );
}

export default ReservationListTab1Component;
